import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const colors = ['#CB0404', '#4ED7F1', '#0D4715']; // You can add more colors if needed

export const BookingBarChart = ({ bookingdata }: any) => {
  const categories = bookingdata?.items.map((item: any) => item.Name) || [];

  const data =
    bookingdata?.items.map((item: any, index: number) => ({
      name: item?.Name,
      y: item?.Value ?? 0,
      color: colors[index % colors.length], // Cycle colors if more data points
    })) || [];

  const options: Highcharts.Options = {
    chart: { type: 'column' },
    title: {
      text: 'Bookings by Platform',
      style: {
        fontSize: '13px',
      },
    },
    xAxis: {
      categories,
      title: { text: null },
      labels: {
        style: {
          fontSize: '0.9rem', // Set month font size
        },
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: 'Bookings',
        style: {
          fontSize: '11px', // ✅ Title font size
        },
      },
      labels: {
        style: {
          fontSize: '12px', // ✅ Y-axis labels font size
        },
      },
    },

    legend: { enabled: false },
    tooltip: {
      pointFormat: '{point.name}: <b>{point.y}</b> bookings',
      style: {
        fontSize: '12px', // Increase this to your preferred size
      },
    },
    plotOptions: { column: { colorByPoint: true } },
    credits: {
      enabled: false,
    },
    series: [
      {
        name: 'Bookings',
        type: 'column',
        data,
      },
    ],
  };

  return (
    <div style={{ maxWidth: 500, margin: '0 auto' }}>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};
